








import { Component, Prop, Vue , Watch } from 'vue-property-decorator';

import Product from './product/product.vue';

import * as def from '@/definitions';

import { ProductCategory as ProductCategoryClass } from '@/data/productCategory/productCategory'
import { Product as ProductClass } from '@/data/productCategory/product/product'

@Component({
  components: {
      Product
  },
})

export default class ProductCategory extends Vue
{
    @Prop()
    private productCategory!: ProductCategoryClass;
    @Prop()
    private selectedProduct!: ProductClass;

    get categoryName(){
        return this.productCategory.name
    }

    get productList(){
        return this.productCategory.productList
    }

    selectProduct(productId : number , productCategoryId : number){
        this.$emit("selectProduct" , productId , productCategoryId)
    }

    decide(){
        this.$emit("decide")
    }

    visibilityChanged(status){
        if(status){
            this.$emit("loadNew");
        }
    }

}

